export class ServerDataBackupingInProgress {
    IsProgressInActiveStatus: boolean;
    IsImportModeSelected: boolean;

    constructor(activeProgress: boolean = false, isImport: boolean = false) {
        this.IsProgressInActiveStatus = activeProgress;
        this.IsImportModeSelected = isImport;
    }
}
